export default {
  namespaced: true,
  state: {
    flight: {},
    flightData: {},
    flightOtherData: {},
    flightDifyAddData: {}
  },
  mutations: {
    ADD_FLIGHT(state, data) {
      Object.assign(state.flight, data);
    },
    ADD_FLIGHT_DATA(state, data) {
      Object.assign(state.flightData, data);
    },
    ADD_FLIGHT_OTHER_DATA(state, data) {
      Object.assign(state.flightOtherData, data);
    },
    ADD_FLIGHT_DIFY_ADD_DATA(state, data) {
      Object.assign(state.flightDifyAddData, data);
    },
    CLEAR_FLIGHT(state) {
      state.flight = {};
      state.flightData = {};
      state.flightOtherData = {};
      state.flightDifyAddData = {};
    }
  },
  actions: {
    addFlight({ commit }, data) {
      commit("ADD_FLIGHT", data);
    },
    addFlightData({ commit }, data) {
      commit("ADD_FLIGHT_DATA", data);
    },
    addFlightOtherData({ commit }, data) {
      commit("ADD_FLIGHT_OTHER_DATA", data);
    },
    addFlightDifyAddData({ commit }, data) {
      commit("ADD_FLIGHT_DIFY_ADD_DATA", data);
    }
  }
};
